import { type Stripe, loadStripe } from '@stripe/stripe-js';
import { client } from './index';

type StripeConfigResponse = {
  publishableKey: string;
};

let cached: Promise<Stripe | null> | null = null;

export const getStripePromise = (): Promise<Stripe | null> => {
  if (!cached) {
    cached = client
      .get<StripeConfigResponse>('/stripe-config')
      .then((res) => loadStripe(res.data.publishableKey))
      .catch((err) => {
        cached = null;
        throw err;
      });
  }
  return cached;
};
